import { render, staticRenderFns } from "./RecettePopUpIngredients.vue?vue&type=template&id=7fdc93ea&scoped=true&"
import script from "./RecettePopUpIngredients.vue?vue&type=script&lang=js&"
export * from "./RecettePopUpIngredients.vue?vue&type=script&lang=js&"
import style0 from "./RecettePopUpIngredients.vue?vue&type=style&index=0&id=7fdc93ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdc93ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fdc93ea')) {
      api.createRecord('7fdc93ea', component.options)
    } else {
      api.reload('7fdc93ea', component.options)
    }
    module.hot.accept("./RecettePopUpIngredients.vue?vue&type=template&id=7fdc93ea&scoped=true&", function () {
      api.rerender('7fdc93ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Recettes/RecettePopUpIngredients.vue"
export default component.exports